import { Button } from '@mantine/core'
import { IconCirclePlus } from '@tabler/icons-react'
import { Typography } from '../../common/typography'
import { CompetitionTeam } from '../../performance/api'
import ComparePickerComponent from './ComparePickerComponent'
import classes from './ComparePicker.module.css'
import { CompareSubject } from '../../compare/Compare'

export default function ComparePicker({
  opened,
  open,
  close,
  teamWithPlayers,
  subject,
  setSubject,
}: {
  opened: boolean
  open: () => void
  close: () => void
  teamWithPlayers: CompetitionTeam[]
  subject: CompareSubject
  setSubject: React.Dispatch<React.SetStateAction<CompareSubject>>
}) {
  return (
    <div className={classes.pickerContainer}>
      <Typography fw={500} lh="130" fc={{ light: 'gray-7', dark: 'gray-3' }}>
        Select Player or Team
      </Typography>
      <Button
        variant="fill"
        classNames={{
          root: classes.compareButtonRoot,
          section: classes.compareButtonSection,
        }}
        onClick={open}
        leftSection={<IconCirclePlus className={classes.compareIcon} />}
      >
        <Typography
          fs="xs"
          fw={500}
          lh="115"
          fc={{ light: 'gray-0', dark: 'gray-0' }}
          tt="uppercase"
        >
          Add
        </Typography>
      </Button>

      <ComparePickerComponent
        opened={opened}
        close={close}
        teamWithPlayers={teamWithPlayers}
        subject={subject}
        setSubject={setSubject}
      />
    </div>
  )
}
